<p-dialog
  styleClass="picker-dialog"
  [(visible)]="visible"
  [modal]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  [focusOnShow]="false"
  appendTo="body"
  [header]="header()"
  [style]="{
    minHeight: '528px',
    height: '80vh',
    width: '50vw'
  }"
  [breakpoints]="{ '768px': '80vw', '576px': '100vw' }"
  (onHide)="onHide()"
>
  <div class="d-flex w-100 my-1 p-inputgroup">
    <span class="p-inputgroup-addon">
      <i class="fa-solid fa-magnifying-glass"></i>
    </span>
    <input
      #filterInput
      pInputText
      type="text"
      class="w-100"
      [(ngModel)]="search"
      (input)="inputSearch()"
    />
    @if (isMultiselect) {
      <span class="p-inputgroup-addon flex-shrink-0">
        <p-checkbox
          [binary]="true"
          [label]="'picker.includeAll' | translate"
          labelStyleClass="text-nowrap"
          [(ngModel)]="allSelected"
          (onChange)="selectAll($event.checked)"
        ></p-checkbox>
      </span>
      @if (type === 'recipe') {
        <button
          pButton
          pRipple
          icon="fa-solid fa-rotate-left"
          class="flex-shrink-0"
          [pTooltip]="'reset' | translate"
          (click)="reset()"
        ></button>
      }
    }
  </div>
  @if (visible) {
    <p-tabView [(activeIndex)]="activeIndex" [scrollable]="true">
      @for (categoryId of categoryIds; track categoryId; let i = $index) {
        <p-tabPanel [selected]="i === activeIndex">
          <ng-template pTemplate="header">
            <i [class]="categoryId | iconSmClass: 'category'"></i>
            <span
              class="d-none d-lg-inline ms-2 ps-1 text-nowrap text-truncate"
              >{{ categoryEntities[categoryId].name }}</span
            >
          </ng-template>
          <ng-template pTemplate="content">
            <p-scrollPanel
              [style]="{ height: 'calc(80vh - 213px)', minHeight: '300px' }"
            >
              @for (ids of categoryRows[categoryId]; track ids) {
                <div class="d-flex flex-wrap">
                  @for (id of ids; track id) {
                    <button
                      pButton
                      pRipple
                      type="button"
                      class="me-1 mb-1"
                      [class.p-button-text]="id !== selection"
                      [class.hover-action]="isMultiselect"
                      [class.hover-active]="
                        selection && selection.indexOf(id) !== -1
                      "
                      [icon]="id | iconSmClass: type"
                      [pTooltip]="tooltip"
                      tooltipPosition="bottom"
                      (click)="clickId(id)"
                    >
                      @if (isMultiselect) {
                        <i class="hover-icon fa-solid fa-eye-slash"></i>
                      }
                      <ng-template #tooltip>
                        <lab-tooltip [id]="id" [type]="type"></lab-tooltip>
                      </ng-template>
                    </button>
                  }
                </div>
              }
            </p-scrollPanel>
          </ng-template>
        </p-tabPanel>
      }
    </p-tabView>
  }

  <ng-template pTemplate="footer">
    @if (isMultiselect) {
      <button
        pButton
        pRipple
        type="button"
        class="p-button-outlined"
        icon="fa-solid fa-check"
        [label]="'ok' | translate"
        (click)="hide()"
      ></button>
    }
    <button
      pButton
      pRipple
      type="button"
      class="p-button-outlined p-button-secondary"
      icon="fa-solid fa-xmark"
      [label]="'cancel' | translate"
      (click)="hide(true)"
    ></button>
  </ng-template>
</p-dialog>
